import React from 'react';
import lottery from '../../lottery';
import style from './TicketNumber.scss';
var TicketNumber = function (_a) {
    var number = _a.number;
    return React.createElement("span", { className: style['ticket-number'] }, number.map(function (numberIndex, index) {
        return React.createElement("span", { key: index }, lottery.number_alphabet[numberIndex]);
    }));
};
export default TicketNumber;
